import Deferred from '@/utils/Deferred'

let deferred

export default {
  namespaced: true,

  state: {
    current_component: null,
    current_component_props: null,
    current_type: null,
    visible: false
  },

  mutations: {
    SHOW(state, { component, props, type }) {
      state.current_component_props = props
      state.current_component = component
      state.current_type = type
      state.visible = true
    },
    HIDE(state, payload) {
      if (!deferred) {
        return
      }
      const cancelStrategy = {
        alert: undefined,
        confirm: false,
        prompt: null
      }
      // Resolve promise with payload or - if omitted - a value that matches the cancel click of the
      // respective DOM apis (window.confirm | window.prompt | window.alert)
      deferred.resolve(payload || cancelStrategy[state.current_type])
      deferred = null
      state.visible = false
      state.current_component = null
      state.current_component_props = null
      state.current_type = null
    }
  },

  actions: {
    SHOW({ dispatch, commit }, { component, props, type }) {
      // Hide any existing dialogs
      dispatch('HIDE')

      deferred = new Deferred()
      commit('SHOW', { component, props, type })

      return deferred.promise
    },
    HIDE({ commit }, payload) {
      commit('HIDE', payload)
    },
    // Shorthands
    PROMPT({ dispatch }, { component, props }) {
      return dispatch('SHOW', { component, props, type: 'prompt' })
    },
    ALERT({ dispatch }, { component, props }) {
      return dispatch('SHOW', { component, props, type: 'alert' })
    },
    CONFIRM({ dispatch }, { component, props }) {
      return dispatch('SHOW', { component, props, type: 'confirm' })
    }
  }
}
